<template>
        <div>
        <v-container fluid>
            <br><br><br>

            <v-row>
                <v-col cols="12" class="pa-0">
                    <barraaplicacion titulo="Configuración de Pantallas"></barraaplicacion>
                </v-col>
            </v-row>            

            <v-row dense v-if="pantallas_nuevas.length > 0" class="mt-3">
                <v-col cols="12" xs="12">
                    <strong>Pantallas nuevas</strong>
                </v-col>
                <v-col>
                    <v-divider></v-divider>
                </v-col>
            </v-row>

            <v-row dense class="mt-1">               
                <v-col cols="12" xs="12" sm="12" v-for="pt of pantallas_nuevas" :key="pt.skid" class="d-flex justify-start">                    
                    <div v-for="pt of pantallas_nuevas" :key="pt.skid" class="pr-2">
                        <v-card elevation="1" dense @click="pantalla(pt.duid, 'nueva')" class="d-inline-flex" color="#FFFDE7">
                            <v-icon :color="colorPantalla(pt.estatus)" class="pl-1 pr-1 mt-1 mb-1" >
                                mdi-television
                            </v-icon>
                            <div class="d-flex flex-column">                                    
                                <v-card-title class="caption mt-1 pl-0 pt-1 pb-0">
                                    {{pt.duid}}
                                </v-card-title>
                            </div>                                
                        </v-card>
                    </div>                    
                </v-col>
            </v-row>

            <v-row dense class="mt-3">
                <v-col cols="12" xs="12">
                    <strong>Pantallas registradas</strong>
                </v-col>
                <v-col>
                    <v-divider></v-divider>
                </v-col>
            </v-row>

            <v-row dense>
               <v-col cols = "12" xs = "12" sm = "12" class="d-flex justify-start">

                    <div class="pantallas d-flex">
                        <div v-for="pt of pantallas_registradas" :key="pt.skid" class="pr-2">
                            <v-card :color="pt.estatus" elevation="1" dense  class="d-inline-flex" width="250px">                            
                                <v-icon color="black" class="pl-1 pr-1" medium >
                                    mdi-television
                                </v-icon>
                                <div class="d-flex flex-column">                                                                
                                    <v-card-title class="caption ma-0 pl-0 pt-1 pb-0">
                                        {{pt.sucursal}}
                                    </v-card-title>
                                    <v-card-subtitle class="caption ma-0 pl-0 pb-1 pt-0">
                                        {{pt.canal}}                                    
                                    </v-card-subtitle>   
                                    <div class="text-caption font-weight-black pr-1">{{pt.nombre}}</div>                                                             
                                </div>
                                <v-spacer></v-spacer>
                                <div>                                    
                                    <v-icon small v-if="pt.estatus!=''" @click="regargar_pantalla(pt.duid)">mdi-refresh</v-icon>
                                    <v-icon small v-if="pt.estatus!=''" @click="pantalla(pt.duid, pt.estatus, pt.nombre, pt.sucursal, pt.id_canal, pt.duracion)">mdi-cog</v-icon>
                                </div>                            
                            </v-card>
                        </div>
                    </div>

                </v-col>
            </v-row>

            <v-row dense>
                <v-col>
                    <v-divider></v-divider>
                </v-col>
                <v-col cols="12" xs="12" class="mt-5">
                    <strong>Contenido</strong>
                </v-col>
                <v-col>
                    <v-divider></v-divider>
                </v-col>
            </v-row>


            <v-row dense class="mt-8">

                <v-col  cols="12" xs="12" sm="3">
                    <v-select label="Canales" outlined dense :items="ubicaciones"
                              @change="carga_contenido()"
                              v-model="ubicacion_seleccionada"></v-select>
                </v-col>
                <v-col >
                    <v-btn dense outlined color="indigo" @click="dialogo_canal=true">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-col>
            </v-row>

            <v-row v-if="ubicacion_seleccionada">
                <v-col cols="12" xs="12" sm="3">
                    <v-text-field outlined dense label="Titulo" v-model="alta_titulo"></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" sm="4">
                    <v-file-input show-size outlined dense label="Adjuntar" v-model="upload" accept="image/png, image/jpg, image/jpeg, video/mp4, video/ogg">
                    </v-file-input>
                </v-col>

                <v-col cols="12" xs="12" sm="1">
                    <v-btn :loading="btn_cargando" dense outlined color="success" @click="subir_archivo">Subir</v-btn>
                </v-col>

            </v-row>


            <v-row class="d-none d-sm-flex" dense>
                <v-col cols="1">
                    <label>Tipo</label>
                </v-col>
                <v-col cols="1">
                    <label>Orden</label>
                </v-col>
                <v-col cols="2">
                    <label>Titulo</label>
                </v-col>

                <v-spacer></v-spacer>
                <v-col cols="1" class="d-flex">
                     <label>Acciones</label>
                </v-col>

                <v-col cols="12" sm="12">
                    <v-divider></v-divider>
                </v-col>

            </v-row>

            <v-row v-for="r of contenido" :key="r.ccontenido" class="pl-1" dense >
                <v-col  xs="1" sm="1" class="d-flex" >
                    <v-icon color="secondary" v-if="r.tipo == 'video'" @click="vistaPrevia(r.tipo, r.url)">mdi-video</v-icon>
                    <v-icon color="secondary" v-if="r.tipo == 'img'" @click="vistaPrevia(r.tipo, r.url)">mdi-image</v-icon>
                </v-col>

                <v-col  xs="1" sm="1" class="d-flex justify-start" >
                    {{r.orden}}
                </v-col>

                <v-col cols="12" sm="2" class="d-flex" >
                    <strong>{{r.titulo}}</strong>
                </v-col>



                <v-spacer></v-spacer>
                <v-col cols="12" sm="1" class="d-flex justify-end">
                    <v-icon v-if="r.activo == 0" @click="activar_desactivar(r.ccontenido, 1)">mdi-eye-off</v-icon>
                    <v-icon v-if="r.activo == 1" @click="activar_desactivar(r.ccontenido, 0)">mdi-eye</v-icon>
                    <v-icon >mdi-pencil</v-icon>
                    <v-icon @click="eliminar_elemento(r.ccontenido)">mdi-delete</v-icon>
                </v-col>

                <v-col cols="12" sm="12">
                    <v-divider></v-divider>
                </v-col>

            </v-row>
            <dialogocarga :estatus="dialogo" :mensaje="dialogo_mensaje"></dialogocarga>
        </v-container>


        <v-dialog v-model="dialogo_canal" persistent hide-overlay width="400">
            <div class="resaltar pa-6">
                <v-text-field v-model="nuevo_canal" label="Nuevo canal" dense outlined></v-text-field>
                <div class="d-flex justify-end">
                    <v-btn color="success" outlined class="mr-2" @click="guarda_canal">Guardar</v-btn>
                    <v-btn color="error" outlined @click="dialogo_canal=false">Cancelar</v-btn>
                </div>
            </div>
        </v-dialog>

        <!-- Configuración de pantalla -->
        <v-dialog v-model="dialogo_cfg" persistent hide-overlay width="400">
            <div class="resaltar pa-6">
                <div class="d-flex justify-center mb-5">Configuración de pantalla</div>
                <div class="d-flex justify-center mb-5">{{pantalla_seleccionada}}</div>
                
                <v-text-field v-model="pantalla_seleccionada_nombre" dense outlined label="Pantalla"></v-text-field>

                <v-select label="Sucursal" outlined dense :items="sucursales"
                              v-model="suc_seleccionada"></v-select>
                <v-select label="Canal" outlined dense :items="canales"
                              v-model="can_seleccionado"></v-select>
                
                <v-text-field v-model="duracion_imagen" dense outlined label="Duración de imagen" suffix="segs"></v-text-field>

                <div class="d-flex justify-end">
                    <v-btn color="success" outlined class="mr-2" @click="pantalla_cfg(pantalla_seleccionada)">Guardar</v-btn>
                    <v-btn color="error" outlined @click="dialogo_cfg=false">Cancelar</v-btn>
                </div>
            </div>
        </v-dialog>


        <!-- Vista previa del elemento -->
        <v-dialog v-model="dialogo_vistaprevia"  hide-overlay width="600">
            <div class="resaltar pa-6">
                <div class="d-flex justify-center mb-5">Vista previa</div>
                <center>
                    <img :src="vp_imagen" alt="" width="500" v-if="vp_imagen != ''">
                    <video :src="vp_video" controls width="500" v-if="vp_video != ''"></video>
                </center>
                <div class="d-flex justify-end">
                    <v-btn color="error" outlined @click="dialogo_vistaprevia=false">Cerrar</v-btn>
                </div>
            </div>
        </v-dialog>



        <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color='snackbar_color' ><strong>{{snackbar_msj}}</strong></v-snackbar>

        </div>
</template>

<script>
import axios from 'axios'
import io from 'socket.io-client'
import barraaplicacion from '@/components/BarraAplicacion'
import dialogocarga from '@/components/DialogoCarga'
export default {
    components:{
        barraaplicacion,
        dialogocarga
    },

    data() {
        return {
            dialogo: false,
            dialogo_mensaje: null,
            dialogo_canal: false,

            dialogo_cfg: false,
            dialogo_mensaje_cfg: "Pantalla",

            btn_cargando: false,
            ubicaciones: [],
            contenido: [],
            ubicacion_seleccionada: null,
            alta_titulo: "",
            upload: null,
            nuevo_canal: '',
           
            snackbar: false,
            snackbar_timeout: 3000,
            snackbar_color: '',
            snackbar_msj: '',

            socket: null,
            pantallas_nuevas: [],
            pantalla_seleccionada: "",
            pantalla_seleccionada_nombre: "",            
            pantallas_registradas: [],

            sucursales: [],
            canales: [],
            suc_seleccionada: '',
            can_seleccionado: '',
            duracion_imagen: 4,

            dialogo_vistaprevia: false,
            vp_imagen: "",
            vp_video: "",

        }
    },

    created() {

        this.getSucursales()
        this.getUbicaciones()
        this.getPantallasRegistradas()

        this.dialogo_mensaje = 'Consultando información'
        this.dialogo = true;

        axios.get(this.$url+'/pantallas/ubicaciones')
            .then((response)=>{
                this.dialogo = false;
                let jsubicaciones  = response.data
                for(let ubicacion of jsubicaciones)
                    this.ubicaciones.push({text:ubicacion.descripcion, value:ubicacion.cubicacion})

            })

        //Intentar conectar con el socket
        try {
            this.socket = io('https://www.abacloud.com.mx:444')
            // this.socket = io('http://www.abacloud.com.mx:3999')
            // this.socket = io('http://177.238.248.42:3999')
            

            //Notificar conexión de configuración a servidor
            this.socket.emit('papc-conectado', '');

            this.socket.on('pas-nuevas', (pantallas)=>{
                this.pantallas_nuevas = pantallas
            })

            this.socket.on('pas-conectadas', (conectadas)=>{

                let clientes_conectados = conectadas.length;


                for(let pr of this.pantallas_registradas){
                    if(clientes_conectados == 0)
                        pr.estatus = ""

                    for(let pc of conectadas){
                        if(pr.duid == pc.duid){
                            pr.estatus = "#E8F5E9"
                            break;
                        }
                        else{
                            pr.estatus = ""
                        }
                    }
                }
            })

        } catch (error) {
            alert("No se pudo conectar al socket. "+error)
        }
    },


    methods: {

        carga_contenido: function() {

            this.dialogo_mensaje = 'Consultando información'
            this.dialogo = true

            if(this.ubicacion_seleccionada != null){
                axios.get(this.$url+"/pantallas/contenido/"+this.ubicacion_seleccionada+"/todos")
                .then((response)=>{
                    this.contenido = response.data
                    this.dialogo = false;
                })
                .catch((error)=>{
                    this.dialogo = false;
                })
            }
        },

        activar_desactivar(id, estatus){

            axios.put(this.$url+'/pantallas/contenido/estatus', {"ccontenido":id, "estatus":estatus})
                .then((response)=>{

                    let respuesta = response.data

                    if(respuesta.estatus){
                        let index = this.contenido.findIndex((element) => element.ccontenido == id)
                        this.contenido[index].activo = estatus
                    }
                })


        },

        subir_archivo(){

            if(this.alta_titulo == "" || this.upload == ""){
                this.snackbar = true;
                this.snackbar_msj = "Información faltante.";
                this.snackbar_color = 'error black--text'
                return false;
            }

            let data = new FormData();

            data.set('enctype', 'multipart/form-data')
            data.append('archivo', this.upload)
            data.append('titulo', this.alta_titulo)
            data.append('ubicacion', this.ubicacion_seleccionada)
            data.append('_method', 'PUT')

            //Mostrar mensaje en pantalla
            this.dialogo_mensaje ='Subiendo archivo'
            this.dialogo = true
            this.btn_cargando = true

            console.log("Subiendo archivo...");

            axios.put(this.$url+'/pantallas/contenido/agregar',data, 
                        {
                            onUploadProgress: progressEvent =>{
                               
                                this.dialogo_mensaje ='Subiendo contenido... '+ Math.round(progressEvent.loaded / progressEvent.total * 100) + "%"
                                
                            }
                        }                        
                    )
                .then((response)=>{
                    if(response.data.estatus){
                        this.dialogo = false
                        this.btn_cargando = false
                        this.carga_contenido()
                        this.limpiar_campos()
                    }
                    else{
                        this.dialogo = false
                        this.snackbar = true
                        this.btn_cargando = false
                        this.snackbar_msj = response.data.mensaje
                        this.snackbar_color = 'error black--text'
                    }
                })
                .catch((error)=>{
                    console.log("Mensaje error: "+error);
                    this.dialogo = false
                    this.btn_cargando = false
                })


        },

        eliminar_elemento(ccontenido){

             //Mostrar mensaje en pantalla
            this.dialogo_mensaje ='Eliminando elemento'
            this.dialogo = true

            axios.delete(this.$url+'/pantallas/contenido/eliminar/'+ccontenido)
                .then((response)=>{
                    if(response.data.estatus){
                        this.dialogo = false
                        this.carga_contenido()
                    }
                })
                .catch((error)=>{
                    console.log("Mensaje error: "+error);
                })
        },

        guarda_canal(){
            axios.post(this.$url+'/pantallas/ubicacion/registrar', {"canal":this.nuevo_canal})
                .then((response)=>{
                    let data = response.data
                    if(data.estatus){
                        this.dialogo_canal = false
                        this.ubicaciones.push({text:this.nuevo_canal.toUpperCase(), value:data.cubicacion})
                        this.nuevo_canal = ''
                        this.snackbar = true;
                        this.snackbar_msj = 'Canal agregado.';
                        this.snackbar_color = 'success white--text'
                    }
                    else{
                        this.dialogo_canal = false
                        this.snackbar = true;
                        this.snackbar_msj = data.mensaje;
                        this.snackbar_color = 'error black--text'
                    }
                })
                .catch((error)=>{
                    console.log(error);
                    this.dialogo_canal = false
                    this.snackbar = true;
                    this.snackbar_msj = 'Ocurrió un problema.';
                    this.snackbar_color = 'error black--text'
                })
        },


        limpiar_campos(){
            this.alta_titulo = ''
            this.upload = null            
        },


        vistaPrevia(tipo, url){
            this.vp_imagen = ''
            this.vp_video = ''

            if(tipo == 'img')
                this.vp_imagen = 'https://www.abacloud.com.mx:444/abacloudserver/multimedia/'+url
                // this.vp_imagen = 'http://177.238.248.42:4000/abacloudserver/multimedia/'+url
            if(tipo == 'video')
                this.vp_video = 'https://www.abacloud.com.mx:444/abacloudserver/multimedia/'+url
                // this.vp_video = 'http://177.238.248.42:4000/abacloudserver/multimedia/'+url

            this.dialogo_vistaprevia = true
        },


        /////////////// Pantallas ///////////////

        pantalla(duid, estatus, nombre, sucursal, id_canal, duracion){
            if(estatus != ''){
                this.pantalla_seleccionada = duid;
                this.pantalla_seleccionada_nombre = nombre;
                this.suc_seleccionada = sucursal;
                this.can_seleccionado = id_canal;
                this.duracion_imagen = duracion;

                console.log(this.pantalla_seleccionada_canal);


                this.dialogo_cfg = true;
            }
        },

        pantalla_cfg(duid){

            if(this.suc_seleccionada != "" && this.can_seleccionado != "" ){

                let config = {pantalla: duid, sucursal:this.suc_seleccionada, canal:this.can_seleccionado, duracion: this.duracion_imagen}
                this.socket.emit('papc-configura', config)

                this.guardarPantalla(duid)

                this.suc_seleccionada = ""
                this.can_seleccionado = ""
                this.duracion_imagen = 4
                this.dialogo_cfg = false

            }

        },

        regargar_pantalla(duid){
            this.socket.emit('papc-recarga', duid)
        },

        getSucursales(){
            axios.get(this.$url+'/pantallas/sucursales')
                .then((response)=>{
                    const arr_suc = response.data
                    for(let suc of arr_suc)
                       this.sucursales.push({text:suc.descripcion, value:suc.sucursal})
                })
        },

        getUbicaciones() {
            axios.get(this.$url+'/pantallas/ubicaciones')
                .then((response)=>{
                    const arr_ubi = response.data
                    for(let can of arr_ubi)
                        this.canales.push({text:can.descripcion, value:can.cubicacion})
                })
        },

        guardarPantalla(duid, callback){
            axios.post(this.$url+'/pantallas/nuevapantalla', {
                    duid:duid,
                    sucursal:this.suc_seleccionada,
                    canal:this.can_seleccionado,
                    duracion: this.duracion_imagen,
                    nombre_pantalla: this.pantalla_seleccionada_nombre
                })
                .then((response)=>{
                    const data = response.data
                    this.getPantallasRegistradas()
                })
        },

        getPantallasRegistradas(){
            axios.get(this.$url+'/pantallas/registradas')
                .then((response)=>{
                    let data = response.data;
                    if(data.estatus){
                        this.pantallas_registradas = data.pantallas
                        this.getPantallasConectadas()
                    }
                })
                .catch((error)=>{
                    console.log("Error al consultar pantallas registradas "+error);
                })
        },

        getPantallasConectadas(){
            if(this.socket != null)
                this.socket.emit('papc-conectado', '');
        },

        colorPantalla(estatus){

            if(estatus == 0)
                return '#F9A825'
                // return '#FFCA28'
            if(estatus == 1)
                return 'green'

        }


    },

}
</script>

<style>
    .pantallas{ 
        width: 100%;
        height: 100px;
        overflow-x: auto;
        white-space: nowrap;
    }
</style>


